import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.date.now.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { lego } from '@zz-common/lego';
import cookie from './cookie';

/**
 * 水印 模块，接入使用请参考：<a href="https://dashen.zhuanspirit.com/pages/viewpage.action?pageId=518333305" target="_blank">水印能力使用</a>
 * @module watermark
 */

import axios from 'axios';
import { $isServer } from './env';

// 明水印图片
var visibleImage = '';
// 暗水印图片
var invisibleImage = '';
// 明水印配置
var visibleSettings = {};
// 暗水印配置
var invisibleSettings = {};
// 其他配置
var otherConfig = {};
// 水印observer
var waterMarkObserver;
// 暗水印外层结构
var outerRootClassName = 'zant-layout-umi-outside-logo';
var outerTailClassName = 'zant-layout-umi-head-logo-type';
var outerLevelOneClassName = 'zant-layout-umi-has-head';
var outerLevelTwoClassName = 'zant-layout-umi-head-lego';
// 只有这四个元素需要被监听变化，他们是暗水印的外层元素，不可变更
var outerMainClassName = [outerRootClassName, outerLevelOneClassName, outerLevelTwoClassName, outerTailClassName];
var outerStructure = {
  type: 'div',
  className: outerRootClassName,
  children: [{
    type: 'div',
    className: 'zant-layout-umi-logo-links',
    children: [{
      type: 'section',
      className: 'zant-layout-umi-logo-links-text'
    }]
  }, {
    type: 'div',
    className: outerLevelOneClassName,
    children: [{
      type: 'section',
      className: outerLevelTwoClassName,
      children: [{
        type: 'div',
        className: outerTailClassName
      } // 存放暗水印的地方
      ]
    }]
  }]
};

/**
 * 初始化水印
 * @method init
 * @param  { String } [parent=body] 水印元素父容器css选择器，默认为body
 * @param  { Object } [visibleOpts={}] 明水印配置
 * @param  { String|String[] } visibleOpts.content 水印内容，多行内容使用数组，优先级高于默认的员工信息（可供未接入sso登录体系的系统使用）
 * @param  { Boolean} [visibleOpts.showUserInfo=true] 展示默认的用户信息，true则将content内容补充到用户信息后，false则不展示用户信息完全按照content进行展示
 * @param  { String } [visibleOpts.waterMarkId=zhuanspirit-watermark-visible] 水印ID
 * @param  { Number } [visibleOpts.zIndex=2000] 水印层级
 * @param  { Object } [visibleOpts.markStyle={}] 水印层的样式
 * @param  { Number } [visibleOpts.gapX=212] 水印之间的水平间距
 * @param  { Number } [visibleOpts.gapY=222] 水印之间的垂直间距
 * @param  { Number } [visibleOpts.width=120] 水印的宽度
 * @param  { Number } [visibleOpts.height=64] 水印的高度
 * @param  { Number } [visibleOpts.offsetTop=111] 水印在canvas 画布上绘制的垂直偏移量，默认绘制在中间位置, 即 offsetTop = gapY / 2
 * @param  { Number } [visibleOpts.offsetLeft=106] 水印在canvas 画布上绘制的水平偏移量, 默认绘制在中间位置, 即 offsetTop = gapX / 2
 * @param  { Number } [visibleOpts.rotate=-22] 水印绘制时，旋转的角度，单位 °
 * @param  { 'none' | 'normal' | 'italic' | 'oblique' } [visibleOpts.fontStyle=normal] 文字样式
 * @param  { 'normal' | 'light' | 'weight' | number } [visibleOpts.fontWeight=normal] 文字粗细
 * @param  { String } [visibleOpts.fontColor=rgba(100, 100, 100, 0.15)] 文字颜色
 * @param  { Number|String } [visibleOpts.fontSize=14] 文字大小
 * @param  { String } [visibleOpts.fontFamily=sans-serif] 文字族
 * @param  { Object } [invisibleOpts={}] 暗水印配置，除下方所列属性默认值与明水印不同，其他均相同（暗水印Id不可配置）
 * @param  { String } [invisibleOpts.fontColor=rgba(0, 0, 0, 0.01)] 文字颜色
 * @param  { Number|String } [invisibleOpts.fontSize=16] 文字大小
 * @param  { String } [invisibleOpts.markStyle={backgroundPosition: '120px 100px'}] 水印层的样式
 * @param  { Object } [otherConfig={}] 其他配置
 * @param  { boolean } [otherConfig.alwaysGetUserInfo=false] 是否总是获取用户信息，默认情况下如果cookie.get('sso_uid')为空，则不请求；当前端页面是m.zhuanzhuan.com的后台时，可以设置为true
 * @return { Promise<{visibleImage,invisibleImage,userInfo}> } 返回明、暗水印的图片和用户的基本信息
 */
var init = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(parent) {
    var visibleOpts,
      invisibleOpts,
      otherOpts,
      defaultVisble,
      defaultInvisible,
      userInfo,
      needShowUserInfo,
      localRecord,
      registeredPath,
      currentPath,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          visibleOpts = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
          invisibleOpts = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
          otherOpts = _args.length > 3 && _args[3] !== undefined ? _args[3] : {};
          _context.prev = 3;
          if (!($isServer || window.__POWERED_BY_QIANKUN__)) {
            _context.next = 6;
            break;
          }
          return _context.abrupt("return");
        case 6:
          // 默认配置
          defaultVisble = {
            parentNodeSelector: 'body',
            waterMarkId: 'zhuanspirit-watermark-visible',
            content: '',
            showUserInfo: true,
            image: '',
            markStyle: {},
            gapX: 212,
            gapY: 222,
            zIndex: 2000,
            width: 120,
            height: 64,
            offsetLeft: 106,
            offsetTop: 111,
            rotate: -22,
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontColor: 'rgba(100, 100, 100, 0.15)',
            fontSize: 14,
            fontFamily: 'sans-serif'
          };
          defaultInvisible = _objectSpread(_objectSpread({}, defaultVisble), {}, {
            markStyle: {
              backgroundPosition: '120px 100px'
            },
            waterMarkId: 'zant-layout-umi-head-logo-type-bg',
            // 随便写的，为了隐蔽，不跟业务的id重名就行...
            fontColor: 'rgba(0, 0, 0, 0.01)',
            fontSize: 16
          }); // 合并配置项
          visibleSettings = _objectSpread(_objectSpread(_objectSpread({}, defaultVisble), visibleOpts), {}, {
            parentNodeSelector: parent || 'body'
          });
          invisibleSettings = _objectSpread(_objectSpread(_objectSpread({}, defaultInvisible), invisibleOpts), {}, {
            parentNodeSelector: parent || 'body'
          });
          otherConfig = otherOpts;
          // 将接口请求的数据，返回给用户
          // 请求用户个人信息
          // (当前系统接入了sso，并且只要有一个水印需要展示默认信息) || 设置了总是需要请求接口 =》才请求接口
          needShowUserInfo = cookie.get('sso_uid') && (visibleSettings.showUserInfo || invisibleSettings.showUserInfo);
          if (!(needShowUserInfo || otherConfig.alwaysGetUserInfo)) {
            _context.next = 16;
            break;
          }
          _context.next = 15;
          return setDefaultWaterMarkContent(visibleOpts.content, invisibleOpts.content);
        case 15:
          userInfo = _context.sent;
        case 16:
          _context.next = 18;
          return generateImage(visibleSettings);
        case 18:
          visibleImage = _context.sent;
          _context.next = 21;
          return generateImage(invisibleSettings);
        case 21:
          invisibleImage = _context.sent;
          loadWaterMark();

          // 记录当前项目信息，便于后续统计接入情况
          localRecord = localStorage.getItem('init_watermark');
          registeredPath = localRecord && JSON.parse(localRecord); // 确保registeredPath是个数组
          if (!Array.isArray(registeredPath)) registeredPath = [];
          currentPath = location.hostname + location.pathname;
          if (!registeredPath.includes(currentPath)) {
            lego.send({
              actiontype: 'zz-utils',
              pagetype: 'INIT_WATERMARK',
              backup: {
                pageUrl: currentPath
              }
            });
            registeredPath.push(currentPath);
            localStorage.setItem('init_watermark', JSON.stringify(registeredPath));
          }
          return _context.abrupt("return", {
            visibleImage: visibleImage,
            invisibleImage: invisibleImage,
            userInfo: userInfo
          });
        case 31:
          _context.prev = 31;
          _context.t0 = _context["catch"](3);
          console.log('水印初始化失败！ :>> ', _context.t0);
        case 34:
          return _context.abrupt("return", {});
        case 35:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 31]]);
  }));
  return function init(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * 重新加载水印，需要在初始化之后使用；
 * 可用于目标元素被删除后又添加回来时，重新加载水印
 * @method reload
 */
var reload = function reload() {
  if ($isServer) return;
  loadWaterMark();
};

// 加载水印
var loadWaterMark = function loadWaterMark() {
  if (!visibleImage || !invisibleImage) return;

  // 先删除之前的水印
  removeWaterMark();

  // 获取水印父容器
  var parentElement = document.querySelector(visibleSettings.parentNodeSelector);

  // 没找到父容器，持续观察
  if (!parentElement) {
    lookForParentNode();
    return;
  }

  // 如果父容器没有设置定位，则设置为reletive
  if (!['relative', 'absolute', 'sticky', 'fixed'].includes(parentElement.style.position)) {
    parentElement.style.position = 'relative';
  }

  // 创建明暗水印元素
  var visibleElement = document.createElement('div');
  var invisibleElement = document.createElement('div');
  visibleElement.id = visibleSettings.waterMarkId;
  invisibleElement.id = invisibleSettings.waterMarkId;
  var commonStyle = {
    position: 'fixed',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    backgroundRepeat: 'repeat'
  };
  visibleElement.style.cssText = styleObjToString(_objectSpread(_objectSpread({}, commonStyle), {}, {
    backgroundSize: "".concat(visibleSettings.gapX + visibleSettings.width, "px"),
    backgroundImage: "url('".concat(visibleImage, "')"),
    zIndex: visibleSettings.zIndex
  }, visibleSettings.markStyle));
  invisibleElement.style.cssText = styleObjToString(_objectSpread(_objectSpread({}, commonStyle), {}, {
    backgroundSize: "".concat(invisibleSettings.gapX + invisibleSettings.width, "px"),
    backgroundImage: "url('".concat(invisibleImage, "')"),
    zIndex: visibleSettings.zIndex
  }, invisibleSettings.markStyle));

  // 创建暗水印的外层元素，用于隐藏暗水印
  var invisibleWatermarkRoot = createSimpleDom(outerStructure);
  // 暗水印先放到外层容器末级中，在将容器插入到父元素中
  var invisibleWatermarkTail = invisibleWatermarkRoot.querySelector(".".concat(outerTailClassName));
  if (invisibleWatermarkRoot && invisibleWatermarkTail) {
    invisibleWatermarkTail.appendChild(invisibleElement);
    parentElement.appendChild(invisibleWatermarkRoot);
  }
  // 明水印直接插入到父元素中
  parentElement.appendChild(visibleElement);

  // 开始观察 防止水印被去掉
  observeWaterMarkNode();
};

// 观察水印元素，被修改或删除后重新加载水印
var observeWaterMarkNode = function observeWaterMarkNode() {
  var parentNode = document.querySelector(visibleSettings.parentNodeSelector);
  var visibleNode = document.querySelector("#".concat(visibleSettings.waterMarkId));
  var invisibleNode = document.querySelector("#".concat(invisibleSettings.waterMarkId));
  var outerMainNodes = outerMainClassName.map(function (clasName) {
    return document.querySelector(".".concat(clasName));
  }).filter(function (n) {
    return !!n;
  });
  var targetNodeList = [].concat(_toConsumableArray(outerMainNodes), [invisibleNode, visibleNode]);
  waterMarkObserver = new MutationObserver(function (mutationList) {
    for (var i = 0; i < mutationList.length; i++) {
      var record = mutationList[i];
      var type = record.type,
        target = record.target,
        removedNodes = record.removedNodes;
      var removedNodeList = removedNodes ? [].slice.call(removedNodes) : [];
      // 重置水印触发条件
      // 1.修改水印属性
      var modifyAttributes = type === 'attributes' && targetNodeList.includes(target);
      // 2.删除水印
      var deleteNode = record.type === 'childList' && removedNodes.length && removedNodeList.some(function (node) {
        return node.contains(invisibleNode) || node.contains(visibleNode);
      });
      if (modifyAttributes || deleteNode) {
        loadWaterMark();
        // 把target 和 removedNodes合到一起，只要发现有可见水印，修改/删除目标就是可见水印
        var isVisibleWaterMark = [].concat(_toConsumableArray(removedNodeList), [target]).includes(visibleNode);
        lego.send({
          actiontype: 'zz-utils',
          pagetype: 'DELETE_WATERMARK',
          backup: {
            deleteTarget: isVisibleWaterMark ? '明水印' : '暗水印',
            visibleContent: visibleSettings.content,
            inVisibleContent: invisibleSettings.content,
            pageUrl: location.href
          }
        });
        break;
      }
    }
  });
  waterMarkObserver.observe(parentNode, {
    childList: true,
    attributes: true,
    subtree: true
  });
};

// 移除水印
var removeWaterMark = function removeWaterMark() {
  // 如果已经初始化过，需要先关闭监听器
  waterMarkObserver && waterMarkObserver.disconnect && waterMarkObserver.disconnect();
  // 如果元素存在则移除
  var preVisibleElement = document.querySelector("#".concat(visibleSettings.waterMarkId));
  var preInvisibleElement = document.querySelector(".".concat(outerRootClassName));
  preVisibleElement && preVisibleElement.remove();
  preInvisibleElement && preInvisibleElement.remove();
};

// 查找父容器元素，等待出现后加载水印
var lookForParentNode = function lookForParentNode() {
  var targetNode = document.body;
  var observer = new MutationObserver(function () {
    // 找到父容器后销毁监视器，并自动执行load
    if (document.querySelector(visibleSettings.parentNodeSelector)) {
      observer.disconnect();
      loadWaterMark();
    }
  });

  // 绑定目标节点并启动监视者
  observer.observe(targetNode, {
    childList: true,
    subtree: true
  });
};

// 将个人信息生成图片
var generateImage = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(setting) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", new Promise(function (reslove) {
            var result = '';
            var content = setting.content,
              image = setting.image,
              gapX = setting.gapX,
              gapY = setting.gapY,
              width = setting.width,
              height = setting.height,
              offsetLeft = setting.offsetLeft,
              offsetTop = setting.offsetTop,
              rotate = setting.rotate,
              fontSize = setting.fontSize,
              fontStyle = setting.fontStyle,
              fontWeight = setting.fontWeight,
              fontFamily = setting.fontFamily,
              fontColor = setting.fontColor;
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            var ratio = getPixelRatio(ctx);
            var canvasWidth = "".concat((gapX + width) * ratio, "px");
            var canvasHeight = "".concat((gapY + height) * ratio, "px");
            var canvasOffsetLeft = offsetLeft || gapX / 2;
            var canvasOffsetTop = offsetTop || gapY / 2;
            canvas.setAttribute('width', canvasWidth);
            canvas.setAttribute('height', canvasHeight);
            if (!ctx) {
              // eslint-disable-next-line no-console
              console.error('当前环境不支持Canvas');
              return;
            }

            // 旋转字符 rotate
            ctx.translate(canvasOffsetLeft * ratio, canvasOffsetTop * ratio);
            ctx.rotate(Math.PI / 180 * Number(rotate));
            var markWidth = width * ratio;
            var markHeight = height * ratio;

            // 往canvas上填写内容
            var writeContent = function writeContent(contentText) {
              var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
              var markSize = Number(fontSize) * ratio;
              ctx.font = "".concat(fontStyle, " normal ").concat(fontWeight, " ").concat(markSize, "px/").concat(markHeight, "px ").concat(fontFamily);
              ctx.fillStyle = fontColor;
              if (Array.isArray(contentText)) {
                contentText.forEach(function (item, index) {
                  return ctx.fillText(item, 0, index * markSize + y);
                });
              } else {
                ctx.fillText(contentText, 0, y ? y + markSize : 0);
              }
              result = canvas.toDataURL();
            };

            // 如果有图片
            if (image) {
              var img = new Image();
              img.crossOrigin = 'anonymous';
              img.referrerPolicy = 'no-referrer';
              img.src = image;
              img.onload = function () {
                ctx.drawImage(img, 0, 0, markWidth, markHeight);
                // 画完图片后，在写入文本
                writeContent(content, img.height + 8);
                reslove(result);
              };
              img.onerror = function () {
                writeContent(content);
                reslove(result);
              };
            } else {
              writeContent(content);
              reslove(result);
            }
          }));
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function generateImage(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

// 设置个人信息
var setDefaultWaterMarkContent = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(visibleContent, inVisibleContent) {
    var response, res, visibleExtend, invisibleExtend, _ref4, name, companyName, phoneSuffix, base, timestamp, host, path, hash;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return axios.get('https://oauth.zhuanspirit.com/openApi/generateWatermark', {
            withCredentials: true
          });
        case 2:
          response = _context3.sent;
          res = response.data || {};
          if (!(res.status === 0)) {
            _context3.next = 16;
            break;
          }
          visibleExtend = Array.isArray(visibleContent) ? visibleContent : [visibleContent];
          invisibleExtend = Array.isArray(inVisibleContent) ? inVisibleContent : [inVisibleContent];
          _ref4 = res.data || {}, name = _ref4.name, companyName = _ref4.companyName, phoneSuffix = _ref4.phoneSuffix;
          base = "".concat(name, "-").concat(companyName, "-").concat(phoneSuffix);
          timestamp = Date.now();
          host = location.hostname;
          path = location.pathname;
          hash = location.hash; // 分别设置最终的content
          visibleSettings.content = (visibleSettings.showUserInfo ? [base].concat(_toConsumableArray(visibleExtend)) : visibleExtend).filter(function (n) {
            return !!n;
          });
          invisibleSettings.content = (invisibleSettings.showUserInfo ? [base, timestamp, host, path, hash].concat(_toConsumableArray(invisibleExtend)) : invisibleExtend).filter(function (n) {
            return !!n;
          });
          return _context3.abrupt("return", res.data || {});
        case 16:
          return _context3.abrupt("return", {});
        case 17:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function setDefaultWaterMarkContent(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();

// 返回当前显示设备的物理像素分辨率与CSS像素分辨率之比
var getPixelRatio = function getPixelRatio(context) {
  if (!context) {
    return 1;
  }
  var backingStore = context.backingStorePixelRatio || context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || 1;
  return (window.devicePixelRatio || 1) / backingStore;
};

// 将驼峰属性转为标准样式属性
var styleObjToString = function styleObjToString(styleObj) {
  return Object.keys(styleObj).reduce(function (pre, key) {
    var kebabCaseKey = key.replace(/([A-Z])/g, '-$1').toLowerCase();
    return "".concat(pre).concat(kebabCaseKey, ":").concat(styleObj[key], ";");
  }, '');
};

// 创建元素
var createSimpleDom = function createSimpleDom(root) {
  var _root$type = root.type,
    type = _root$type === void 0 ? 'div' : _root$type,
    _root$className = root.className,
    className = _root$className === void 0 ? '' : _root$className,
    _root$children = root.children,
    children = _root$children === void 0 ? [] : _root$children;
  var containerEle = document.createElement(type);
  if (className) containerEle.className = className;
  if (children.length) {
    children.forEach(function (child) {
      containerEle.appendChild(createSimpleDom(child));
    });
  }
  return containerEle;
};
export default {
  init: init,
  reload: reload,
  remove: removeWaterMark
};